module.exports = __webpack_public_path__ + "img/google.8fa1ce6b.svg";